import React from 'react';
import { Spinner } from 'react-bootstrap';
import useAuthSwitchShared from 'shared/components/AuthSwitch/hooks/useAuthSwitch';
import AppBackgroundType from 'shared/utils/AppBackgroundType';
import AssetPreloader from '../AssetPreloader';
import useAuthSwitch from './useAuthSwitch';
import LazyImage from '../LazyImage/LazyImage';
import { TAG } from 'shared/constants';
import useCacheLoadingScreenAsset from '../../hooks/useCacheLoadingScreenAsset';
import { useSelector, shallowEqual } from 'shared/node_modules/react-redux';
import { getAppBackgroundImage } from 'shared/components/AuthSwitch/utils';

const AuthSwitch = props => {
  useAuthSwitch();
  useCacheLoadingScreenAsset();
  const {
    descriptor,
    hasAssetsLoaded,
    initTextsLoaded,
    SceneView,
    appBackground,
    backgroundPromo,
    isConnected,
    promotionImagesUrl,
  } = useAuthSwitchShared(props);

  const {
    customAppBackgrounds = {},
    slotGames = [],
    tableGames = [],
    vipGames = [],
    sportsGames = [],
    favouriteGames = [],
    gameRooms = [],
  } = useSelector(
    state => ({
      customAppBackgrounds: state.load.initAppResponse?.LOBBY?.backgrounds,
      slotGames: state.slotGames?.gameList,
      tableGames: state.tableGames?.gameList,
      vipGames: state.vipGames?.gameList,
      sportsGames: state.sportsGames?.gameList,
      favouriteGames: state.favouriteGames?.gameList,
      gameRooms: state.gameRooms?.data,
    }),
    shallowEqual
  );

  const mainBackground = getAppBackgroundImage({
    type: isConnected ? appBackground : AppBackgroundType.NORMAL,
    backgroundPromo,
    promotionImagesUrl,
    customAppBackgrounds,
    slotGames,
    tableGames,
    vipGames,
    sportsGames,
    favouriteGames,
    gameRooms,
  });

  return (
    <div className="App">
      <LazyImage
        tag={TAG.IMG}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          zIndex: appBackground === AppBackgroundType.VIP_GAMES ? 1 : -1,
          width: '100vw',
          height: '100dvh',
          overflow: 'hidden',
        }}
        loadingmethod="eager"
        alt="background"
        src={mainBackground}
      />
      {!initTextsLoaded && (
        <div style={{ position: 'absolute', zIndex: 99, top: '50%', left: '50%' }}>
          <Spinner animation="border" />
        </div>
      )}
      {isConnected && initTextsLoaded && (
        <>
          {hasAssetsLoaded ? (
            <SceneView component={descriptor.getComponent()} navigation={descriptor?.navigation} />
          ) : (
            <AssetPreloader navigation={descriptor?.navigation} />
          )}
        </>
      )}
    </div>
  );
};

export default AuthSwitch;
